import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { AssignPermissionsRequest } from "../types";

export const assignPermissions = async ({
  token,
  roleId,
  ...payload
}: AssignPermissionsRequest): Promise<void> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/authorization/roles/${roleId}/permissions`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  await axios.put(url, payload, config);
};

export const useAsignRoles = () => {
  return useMutation(assignPermissions);
};
